import { Namespace } from './namespace.class';
import { BehaviorSubject, Observable } from 'rxjs/index';

export class SessionNamespace<T> extends Namespace<T> {
    private $events: BehaviorSubject<any> = new BehaviorSubject(null);

    public get observable(): Observable<any> {
        return this.$events.asObservable();
    }

    public constructor(public readonly key: string) {
        super(key);
    }

    public get(): T | any {
        const item = localStorage.getItem(this.key);
        if (item) {
            try {
                return JSON.parse(item).data;
            } catch {
                return undefined;
            }
        } else {
            return item;
        }
    }

    public set(data: T): void {
        const item = localStorage.getItem(this.key);
        const now = new Date();
        const raw = item
            ? { ...JSON.parse(item), ...{ modified: now, data } }
            : { created: now, modified: now, data };

        localStorage.setItem(this.key, JSON.stringify(raw));
        this.touch(data);
    }

    public touch(data: T): void {
        this.$events.next({ namespace: this.key, value: data });
    }
}
